var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.15 71.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "a47775f8-0ea7-45bf-bde6-7592df4831b6",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f1c79f60-d2ed-4b74-aa31-76b964917a80",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.45,48.35l-1.3-1.45c.53-.13,1.12-.24,1.75-.33s1.3-.15,2-.2,1.43-.07,2.2-.07a32.36,32.36,0,0,1,12.55,2.22,17.9,17.9,0,0,1,8.12,6.38,17.3,17.3,0,0,1,2.83,10,20.42,20.42,0,0,1-3.2,11.4,21,21,0,0,1-9,7.6A32.81,32.81,0,0,1,27.5,86.6a35.56,35.56,0,0,1-12.93-2A17.49,17.49,0,0,1,6.7,79a13,13,0,0,1-2.65-8,8.27,8.27,0,0,1,2.22-6,7.52,7.52,0,0,1,5.58-2.27,6.72,6.72,0,0,1,5.2,1.9A7.29,7.29,0,0,1,18.8,69.7v4.7a8,8,0,0,0,2.27,5.87q2.28,2.28,6.58,2.28a10.16,10.16,0,0,0,5.8-1.68,11.13,11.13,0,0,0,3.95-5.05,21.76,21.76,0,0,0,1.45-8.57q0-8.14-3.28-11.93t-9.92-3.77h-3.4A3.47,3.47,0,0,1,20,50.9,2.38,2.38,0,0,1,19.2,49a3.31,3.31,0,0,1,.45-1.68,10.42,10.42,0,0,1,1.7-2l22.8-22.9.45,4.4H17.05a5.23,5.23,0,0,0-2.78.62A3.52,3.52,0,0,0,12.9,29.6l-1.25,5.1a3.19,3.19,0,0,1-1,1.7,2.92,2.92,0,0,1-2,.65,3.14,3.14,0,0,1-2.1-.78,2.49,2.49,0,0,1-.65-2.22L7.5,18.6A3.58,3.58,0,0,1,8.88,16,5.28,5.28,0,0,1,12.2,15H50.3a6,6,0,0,1,3,.55,1.85,1.85,0,0,1,.9,1.7,3.7,3.7,0,0,1-.6,1.82,16.79,16.79,0,0,1-2.65,3Z",
    transform: "translate(-4.05 -15)",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.7a1d153a19e98722ae6e711941111149.svg";
export { ForwardRef as ReactComponent };